import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { concat } from "../../utils/classNames.js";
import { useArmstrongConfig } from "../config/config.context.js";
import "./spinner.theme.css.js";
const Spinner = React.forwardRef(({ children, className, icon, fillContainer, label, ...HTMLProps }, ref) => {
  const { spinnerIcon } = useArmstrongConfig({ spinnerIcon: icon });
  return jsxs("div", { ref, className: concat("arm-spinner", className), "data-fill-container": fillContainer, role: "status", "aria-busy": true, "aria-label": "Loading...", ...HTMLProps, children: [jsx("div", { className: "arm-spinner-inner", children: children || spinnerIcon }), label && jsx("div", { className: "arm-spinner-label", children: jsx("span", { children: label }) })] });
});
Spinner.displayName = "Spinner";
Spinner.defaultProps = {
  fillContainer: true
};
export {
  Spinner
};
//# sourceMappingURL=spinner.component.js.map
